import React from "react";
import styled from "styled-components";
import Spinner from "react-spinner-material";

const Container = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-top: 1.5rem;
`;

const ButtonDiv = styled.div`
	background-color: #f9c80e;
	border-radius: 10px;
	color: #18191b;
	padding: 1rem;
	min-width: 200px;
	text-align: center;
	cursor: pointer;
	margin-top: 1rem;
	font-size: 15px;
	font-weight: 800;
	font-family: Visby CF;
	display: flex;
    flex-direction: column;
    align-items: center;
`;

function Button({ ...props }) {
	return (
		<Container>
			{props.isLoading ?
                <ButtonDiv><Spinner radius={22} color="#18191b" stroke={2} visible={true} /></ButtonDiv>
				:
				<ButtonDiv onClick={props.onClick}>{props.text.toUpperCase()}</ButtonDiv>
			}
		</Container>
	);
}

export default Button;
